import { BlogAPI } from '../../../../apis/BlogAPI'
import BlogSection from '../../../../components/BlogSection'
import BlogWrapper from '../../../../components/BlogWrapper'
import { getBlogWrapperPosts } from '../../../../helpers/blog'

export async function getStaticPaths() {
    const { data: categories } = await BlogAPI.safeRequest(
        () => BlogAPI.getCategories(),
        { data: [] },
        'category index getStaticPaths',
    )

    const paths = categories.map((category) => ({
        params: { slug: category.slug },
    }))

    return { paths, fallback: 'blocking' }
}

export async function getStaticProps({ params }) {
    const { slug } = params
    const { data: category } = await BlogAPI.safeRequest(
        () => BlogAPI.getCategoryBySlug(slug),
        { data: [] },
        `category index getCategoryBySlug ${slug}`,
    )
    const categoryId = category[0]?.id
    const categoryName = category[0]?.name

    if (!categoryId || !categoryName) return { notFound: true, revalidate: 10 }

    const { data: posts, headers } = await BlogAPI.safeRequest(
        () => BlogAPI.getBlogPostsByCategoryId(categoryId, 1),
        { data: [], headers: { 'x-wp-totalpages': '0' } },
        `category index getBlogPostsByCategoryId ${slug}`,
    )

    const { initialCategories, latestBlogPosts, tags, popularPosts } =
        await getBlogWrapperPosts()

    const totalPages = parseInt(headers['x-wp-totalpages'], 10)

    return {
        props: {
            initialPosts: posts,
            latestBlogPosts,
            tags,
            popularPosts,
            initialCategories,
            initialTotalPages: totalPages,
            categorySlug: slug,
            categoryName,
        },
        revalidate: 10, // In seconds
    }
}

export default function CategoryPage({
    initialPosts,
    initialCategories,
    initialTotalPages,
    categorySlug,
    categoryName,
    latestBlogPosts,
    tags,
    popularPosts,
}) {
    const title = categoryName ? `Category: ${categoryName}` : 'Category'

    return (
        <BlogWrapper
            {...{
                title,
                latestBlogPosts,
                initialCategories,
                tags,
                popularPosts,
            }}>
            <BlogSection
                initialPage={1}
                initialPosts={initialPosts}
                initialCategories={initialCategories}
                initialTotalPages={initialTotalPages}
                categorySlug={categorySlug}
                paginationPrefix={`/category/${categorySlug}`}
                pageTitle={`Category: ${categoryName}`}
            />
        </BlogWrapper>
    )
}
